//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useState, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import useSimpleBarRef from '../common/hooks/useSimpleBarRef';
// import { ACCOUNT_STATUS_ACTIVE } from '../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { loadOpenInvitations } from '../common/services/empAccountLinkageServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import TopNav from '../topNav/TopNav';
import PageMessage from '../common/elemental/PageMessage';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import EmployerAccountLinkage from './subComponents/EmployerAccountLinkage';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import _size from 'lodash/size';
// import _isNil from 'lodash/isNil';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
        pageHeader: { maxHeight: '81px' },
        pageContent: {
            flex: 1,
            overflow: 'hidden',
        },
        tempContainer: { alignItems: 'center' },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        invitationList,
        // setInvitationList,
    } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
        employerAccountLinkage: { employerInviteList: invitationList },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const PAGE_ID_EMP_ACCOUNT_LINKAGE = 1;
const PAGE_ID_NO_OPEN_INVITATIONS = 2;
// const PAGE_ID_NO_LINKED_EMPLOYERS = 3;
const PAGE_ID_ALL_INVITATION_DECLINED = 4;
const PAGE_ID_BLANK = 5;

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const EmpAccountLinkageLayout = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    const appContext = useContext(AppContext);
    const { currentUser } = appContext;
    const userEmail = _get(currentUser, 'email');
    // const userEmployers = _get(currentUser, 'employers');

    const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    const { /*simpleBarRef: pageContentSimpleBarEl,*/ scrollToTop: scrollToPageTop } = useSimpleBarRef();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [invitationList, setInvitationList] = useState(null);
    const [isLinkageCompleted, setIsLinkageCompleted] = useState(false);
    const [currentPage, setCurrentPage] = useState(PAGE_ID_BLANK);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // Fetch all open invitations for this user
    useEffect(() => {
        const loadData = async () => {
            const list = await loadOpenInvitations({ email: userEmail });
            setInvitationList(list);
            if (_size(list) === 0) {
                setCurrentPage(PAGE_ID_NO_OPEN_INVITATIONS);
            } else {
                setCurrentPage(PAGE_ID_EMP_ACCOUNT_LINKAGE);
            }
        };
        // load the open invitations if they have not been loaded yet
        if (userEmail && invitationList === null) {
            loadData();
        }
    }, [userEmail, invitationList]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const getPageComponent = defns => {
        switch (currentPage) {
            case PAGE_ID_NO_OPEN_INVITATIONS:
                return <PageMessage noOpenInvitation />;
            case PAGE_ID_ALL_INVITATION_DECLINED:
                return <PageMessage allInvitationsDeclined />;
            case PAGE_ID_EMP_ACCOUNT_LINKAGE:
                return <EmployerAccountLinkage {...defns.employerAccountLinkage} />;
            default:
                return null;
        }
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, invitationList, setInvitationList });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...layoutContext, scrollToPageTop, setCurrentPage, isLinkageCompleted, setIsLinkageCompleted }}>
            <Grid {...defns.pageContainer}>
                <Grid {...defns.pageHeader}>
                    <TopNav />
                </Grid>
                <Grid {...defns.pageContent}>
                    {/* <SimpleBar style={{ height: '100%', width: '100%', flex: 1 }} ref={pageContentSimpleBarEl}>
                        <Grid {...defns.tempContainer}>{getPageComponent()}</Grid>
                    </SimpleBar> */}
                    <Grid {...defns.tempContainer}>{getPageComponent(defns)}</Grid>
                </Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default EmpAccountLinkageLayout;
